<template>
  <section class="bg">

    <Header page="answers" :title="question_text" :question_image="question_image" :answer_type="required_answer_type" />

    <div class="main-container">
    <!-- <div> -->

      <!-- Loading if answers are null -->
      <div v-if="!is_data_fetched" class="loading">
        <a-spin>
          <a-icon slot="indicator" type="loading" style="font-size: 40px; color: #1BD285;" spin />
        </a-spin>
      </div>

      <!-- Filters -->
      <Filters
        v-if="is_data_fetched && answers && required_answer_type !== 'multi_choice'"
        :answer_count="answers.length"
        :page="page"
        :total_answer_count="total_filtered_answer_count"
        v-on:selectedFavorites="filterFavorites"
        v-on:selectedNPS="filterNPS"
        v-on:selectedGender="filterGender"
        v-on:selectedAge="filterAge"
      />

      <!-- Pagination -->
      <template v-if="is_data_fetched && answers && this.required_answer_type !== 'multi_choice'">
        <section class="pagination">
          <a-pagination v-model="page" :total="total_filtered_answer_count" :defaultPageSize="20" :hideOnSinglePage="true" />
        </section>
      </template>

      <masonry :cols="is_mobile ? 1 : 3" :gutter="is_mobile ? 15 : 30" v-if="is_data_fetched && answers && this.required_answer_type !== 'multi_choice'">
        <!-- Answer Cards -->
        <AnswerCard v-for="answer in answers" :key="answer.id" :answer="answer" />
      </masonry>

      <!-- Multi-Choice -->
      <template v-if="is_data_fetched && answers && required_answer_type == 'multi_choice'">
        <MultiChoiceAnswer :answers="answers" :multi_choice_options="multi_choice_options" />
      </template>

      <!-- Bottom Pagination -->
      <template v-if="is_data_fetched && answers && this.required_answer_type !== 'multi_choice'">
        <section class="pagination">
          <a-pagination v-model="page" :total="total_filtered_answer_count" :defaultPageSize="20" :hideOnSinglePage="true" />
        </section>
      </template>

    </div>


    <!-- Empty State - No answers in the database -->
    <div v-if="is_data_fetched && answers && answers.length === 0 && this.required_answer_type !== 'multi_choice'">
      <p class="empty-state">No answers yet</p>
      <!-- <template>
        <a-empty />
      </template> -->
    </div>

    <!-- Comment Drawer for the selected answer -->
    <a-drawer
      title="Comments"
      placement="right"
      :closable="true"
      width="400"
      @close="resetComments"
      :visible="comments_answer_id !== null"
    >
      <a-list
        v-if="comments && comments.length"
        :dataSource="comments"
        :header="`${comments.length} ${comments.length > 1 ? 'replies' : 'reply'}`"
        itemLayout="horizontal"
      >
      <a-list-item slot="renderItem" slot-scope="comment, index">
        <a-comment
          :author="comment.author"
          :content="comment.text"
          :datetime="getTimeFromNow(comment.time_created)"
        >
        </a-comment>
      </a-list-item>
      </a-list>
      <a-comment v-if="comments!==null" :author="user_name">
        <!-- <a-avatar
          slot="avatar"
          src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png"
          alt="Han Solo"
        /> -->
        <div slot="content">
          <a-form-item>
            <a-textarea :rows="3" @change="handleCommentInput" :value="new_comment" placeholder="Write your comment"></a-textarea>
          </a-form-item>
          <a-form-item>
            <a-button htmlType="submit" @click="addComment" type="primary">
              Add Comment
            </a-button>
          </a-form-item>
        </div>
      </a-comment>
    </a-drawer>

  </section>
</template>

<script>

import _ from 'lodash';
import moment from 'moment';
import Header from '@/components/Header.vue';
import Filters from '@/components/Filters.vue';

import AnswerCard from '@/components/answers/AnswerCard.vue';
import MultiChoiceAnswer from '@/components/answers/MultiChoiceAnswer.vue';
import { isMobile, isMobileOnly } from 'mobile-device-detect';

export default {
  name: 'answers',
  components: {
    Header,
    Filters,
    AnswerCard,
    MultiChoiceAnswer
  },
  data() {
    return {
      nps_filter: null,
      favorites_filter: null,
      gender_filter: null,
      min_age_filter: null,
      max_age_filter: null,
      page: 1, // Show 20 results per page?
      total_filtered_answer_count: 0, // Show 20 results per page?
      new_comment: "",
      is_mobile: isMobileOnly
    }
  },
  computed: {

    is_data_fetched() {
      let survey_index = this.$route.params.survey_index;
      let surveys = this.$store.state.surveys;
      if (!surveys) {
        return false;
      };
      let survey = this.$store.state.surveys[survey_index];
      if (!survey) {
        return false;
      };
      let question_index = this.$route.params.question_index;
      return this.$store.state.fetched_data[`${survey.id}-${question_index}`];
    },

    comments() {
      let comment_answer_id = this.$store.state.comments_answer_id;
      if (!comment_answer_id) { return [] };
      let survey_index = this.$route.params.survey_index;
      let survey = this.$store.state.surveys[survey_index];
      if (!survey.answers) { return [] };
      let answer = _.find(survey.answers, ['id', comment_answer_id]);
      return answer.comments || [];
    },

    comments_answer_id() {
      return this.$store.state.comments_answer_id;
    },

    user_name() {
      return this.$store.state.user.name || "";
    },

    question() {
      if (this.$store.state.surveys && this.$store.state.surveys.length > 0) {
        let survey = this.$store.state.surveys[this.$route.params.survey_index];
        let question_index = this.$route.params.question_index;
        if (survey && survey.questions) {
          return survey.questions[question_index];
        } else {
          return null;
        };
      } else {
        return null;
      };
    },

    question_text() {
      if (this.question && this.question.text && this.question.text.en) { // TEMP
        return this.question.text.en;
      } else if (this.question && this.question.text) {
        return this.question.text;
      } else {
        return '';
      };
    },

    question_image() {
      return (this.question && this.question.image_urls) ? this.question.image_urls[0] : '';
    },
    required_answer_type() {
      return (this.question && this.question.answer_type) ? this.question.answer_type : '';
    },

    answers() {

      let survey_index = this.$route.params.survey_index;
      let question_index = this.$route.params.question_index;

      if (!this.$store.state.surveys) { // Called if the answers page is loaded directly.
        return null; // null means loading
      };

      if (!this.$store.state.surveys[survey_index].answers) { // Called after surveys set, but answers are still loading
        return null; // null means loading
      };

      let filtered_answers = _.filter(this.$store.state.surveys[survey_index].answers, ['question_index', Number(question_index)]);

      if (!filtered_answers || !filtered_answers.length) {
        return filtered_answers;
      };

      if (this.favorites_filter) {
        filtered_answers = _.filter(filtered_answers, answer => (answer.is_favorited === true));
      };

      // Apply Gender filters
      if (this.nps_filter) {
        filtered_answers = _.filter(filtered_answers, answer => {
          let respondent = this.$store.state.respondents[answer.uid];
          if (respondent) {
            if (this.nps_filter === 'Promoters') {
              return respondent.nps_score >= 9;
            } else if (this.nps_filter === 'Passives') {
              return respondent.nps_score === 7 || respondent.nps_score === 8;
            } else if (this.nps_filter === 'Detractors') {
              return respondent.nps_score <= 6;
            } else {
              return true;
            };
          } else {
            return false;
          }
        });
      };

      // Apply Gender filters
      if (this.gender_filter) {
        filtered_answers = _.filter(filtered_answers, answer => {
          let respondent = this.$store.state.respondents[answer.uid];
          if (respondent) {
            return respondent.gender === this.gender_filter;
          } else {
            return false;
          }
        });
      };

      // Apply Age filters
      if (this.min_age_filter || this.max_age_filter) {
        filtered_answers = _.filter(filtered_answers, answer => {
          let respondent = this.$store.state.respondents[answer.uid];
          if (respondent) {
            return respondent.age >= this.min_age_filter && respondent.age <= this.max_age_filter;
          } else {
            return false;
          }
        });
      };

      // TODO; Remove this once I properly delete answers
      // Don't show deleted answers
      filtered_answers = _.filter(filtered_answers, answer => (answer.is_deleted !== true));
      if (filtered_answers) {
        this.total_filtered_answer_count = filtered_answers.length;
      } else {
        this.total_filtered_answer_count = 0;
      }

      // Paginate the results
      const page_size = 20;
      if (filtered_answers && this.required_answer_type !== 'multi_choice') {
        filtered_answers = filtered_answers.slice(((this.page - 1) * page_size), (this.page * page_size));
      };

      return filtered_answers

    },
    multi_choice_options() {
      return (this.question && this.question.multi_choice) ? this.question.multi_choice : '';
    }
  },

  mounted() {

    let survey_index = this.$route.params.survey_index;
    let question_index = this.$route.params.question_index;
    question_index = parseInt(question_index);

    // User has refreshed the page
    if (!this.$store.state.surveys) {

      var that = this;

      // Give the app 5 seconds to re-auth the user, otherwise take them back to surveys
      setTimeout(function() {
        if (!that.$store.state.surveys) {
          that.$router.replace('/surveys'); // User hasn't authed yet, and therefore survey id hasn't been set - ideally I wait and showing loading instead of redirecting..
        } else {
          that.$store.dispatch('setAnswers', { survey_index, question_index });
        }
      }, 5000);

    } else {

      if (this.$store.state.surveys[survey_index]) { // If the surveys answers haven't been set yet, set them
        this.$store.dispatch('setAnswers', { survey_index, question_index });
      };

    };

  },

  created() {
    analytics.page('Answers');
  },

  methods: {

    // Filter Functions
    filterFavorites: function(show_favorites) {
      this.favorites_filter = show_favorites;
    },
    filterNPS: function(nps) {
      this.nps_filter = (nps === 'all nps') ? null : nps;
    },
    filterGender: function(gender) {
      this.gender_filter = (gender === 'all genders') ? null : gender;
    },
    filterAge: function(min_age, max_age) {
      this.min_age_filter = (min_age === null) ? null : min_age;
      this.max_age_filter = (min_age === null) ? null : max_age;
    },

    handleCommentInput: function(e) {
      this.new_comment = e.target.value;;
    },
    addComment: function() {
      let survey_index = this.$route.params.survey_index;
      this.$store.dispatch('addComment', [survey_index, this.new_comment]);
      this.new_comment = "";
    },

    resetComments: function() {
      this.$store.commit('setCommentsAnswerID', null);
    },

    getTimeFromNow(unix) {
      return moment.unix(unix).fromNow()
    }

  }
};
</script>

<style lang="scss" scoped>

section.bg{
  padding-bottom: 50px;
  background-image: linear-gradient(135deg, #eff0f3 1%,#fefeff 100%);
  min-height: 100%;
}

.main-container{
  width: 970px;
  margin: 0 auto;
  margin-top: 50px;
  font-family: "Montserrat", sans-serif;
}

.loading{
  height: 40px;
  width: 40px;
  margin: 0 auto;
  margin-top: 110px;
  display: block;
}

// Done loading, no answers yet
.empty-state{
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: rgb(30,30,30);
}

.pagination{
  width: 100%;
  margin-top: 15px;
  &:last-of-type{
    margin-top: 75px;
  }
}


@media only screen
and (min-device-width : 320px)
and (max-device-width : 480px) {
.main-container{
  width: 100%;
  padding: 20px;
}

}

@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait) {
  .main-container{
    width: 100%;
    padding: 20px;
  }
}


</style>
